var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('mc-exception500')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }